import i18n from '@/i18n'

export const successMsg = {
  'transition-draft': () => i18n.t('fleetTaskInstant.toast.transition.status.success.draft'),
  'transition-scheduled': () => i18n.t('fleetTaskInstant.toast.transition.status.success.scheduled'),
  'transition-started': () => i18n.t('fleetTaskInstant.toast.transition.status.success.started'),
  'transition-ended': () => i18n.t('fleetTaskInstant.toast.transition.status.success.ended'),
  'transition-canceled': () => i18n.t('fleetTaskInstant.toast.transition.status.success.canceled'),
  'optimized-route-default': () => i18n.t('fleetTaskInstant.toast.optimizeRoute.success'),
  'optimized-route-more-than-one-mile': (distance) =>
    i18n.t('fleetTaskInstant.toast.optimizeRoute.successMoreThanOneMile', { distance }),
  'calculate-schedule-default': () => i18n.t('fleetTaskInstant.toast.calculateSchedule.success'),
  'delete-qa/list': (total) => i18n.t('fleetTaskInstant.toast.deleteQA.success.list', {
    total
  }),
  'delete-qa/detail': (foNumber) => i18n.t('fleetTaskInstant.toast.deleteQA.success.detail', {
    foNumber
  }),
  'duplicate-qa/list': (total) => i18n.t('fleetTaskInstant.toast.duplicateQA.success.list', { total }),
  'duplicate-qa/one': () => i18n.t('fleetTaskInstant.toast.duplicateQA.success.one'),
}

export const errorMsg = {
  'default': () => i18n.t('global.somethingWentWrong'),
  'required-more-point': () => i18n.t('fleetTaskInstant.toast.optimizeRoute.failedNeedMorePoint'),
  'min-one-point': () => i18n.t('fleetTaskInstant.toast.transition.address.minOnePoint'),
  'required-vehicle': () => i18n.t('fleetTaskInstant.toast.transition.vehicle.required'),
  'required-first-point-target-time': () => i18n.t('fleetTaskInstant.toast.calculateSchedule.requiredFirstPointTargetTime'),
  'vehicle_id/already-registered': () => i18n.t('fleetTaskInstant.toast.transition.vehicle.alreadyRegistered'),
  'vehicle_id/value-not-found': () => i18n.t('fleetTaskInstant.toast.transition.vehicle.valueNotFound'),
  'driver_id/already-registered': () => i18n.t('fleetTaskInstant.toast.transition.driver.alreadyRegistered'),
  'driver_id/value-not-found': () => i18n.t('fleetTaskInstant.toast.transition.driver.valueNotFound'),
  'address/point-overlap': () => i18n.t('fleetTaskInstant.toast.transition.address.pointOverlap'),
  'address/value-not-found': () => i18n.t('fleetTaskInstant.toast.transition.address.valueNotFound'),
  'delete-qa/list': (total) => i18n.t('fleetTaskInstant.toast.deleteQA.failed.list', { total }),
  'delete-qa/detail': (foNumber) => i18n.t('fleetTaskInstant.toast.deleteQA.failed.detail', { foNumber }),
  'duplicate-qa/list': (total) => i18n.t('fleetTaskInstant.toast.duplicateQA.failed.list', { total }),
  'duplicate-qa/one': () => i18n.t('fleetTaskInstant.toast.duplicateQA.failed.one'),
  'duplicate-qa/no-selected-data': () => i18n.t('fleetTaskInstant.toast.duplicateQA.failed.noSelectedData'),
  'duplicate-qa/driver-user-group-invalid': (object) => i18n.t('fleetTaskInstant.toast.duplicateQA.failed.userGroupInvalid', { object }),
  'duplicate-qa/vehicle-user-group-invalid': (object) => i18n.t('fleetTaskInstant.toast.duplicateQA.failed.userGroupInvalid', { object }),
  'transition/default': () => i18n.t('fleetTaskInstant.toast.transition.failed'),
  'transition/to-scheduled': () => i18n.t('fleetTaskInstant.toast.transition.list.notDraft'),
  'transition/to-started': () => i18n.t('fleetTaskInstant.toast.transition.list.notDraftOrScheduled'),
  'transition/to-ended': () => i18n.t('fleetTaskInstant.toast.transition.list.notStarted'),
  'transition/to-canceled': () => i18n.t('fleetTaskInstant.toast.transition.list.notStarted')
}
